export * from "./ICoach";
export * from "./IDirectorParams";
export * from "./IDirectorRequest";
export * from "./IEvaluationRequest";
export * from "./ILogin";
export * from "./ILoginCallbackRequest";
export * from "./ILoginCallbackResponse";
export * from "./IResponseSummaryRequest";
export * from "./IResponseSummaryResponse";
export * from "./ISchool";
export * from "./ISchoolIdRequest";
export * from "./ISeason";
export * from "./ISeasonResponse";
export * from "./ISeasonSportRequest";
export * from "./ISeasonsOrderRequest";
export * from "./ISettings";
export * from "./ISport";
export * from "./ISurvey";
export * from "./ISurveyCoachEvaluationRequest";
export * from "./ISurveyComments";
export * from "./ISurveyCountResponse";
export * from "./ISurveyEvaluationRequest";
export * from "./ISurveyEvaluationResponse";
export * from "./ISurveyEvaluationResponses";
export * from "./ISurveyRespondentRequest";
export * from "./ISurveyRespondentResponse";
export * from "./ISurveyResponse";
export * from "./ISurveyResponseRequest";
export * from "./ISurveyWrittenResponseResponse";
export * from "./ITemplate";
export * from "./ITemplateDirectorRequest";
export * from "./IUser";
export * from "./TemplateType";



// WEBPACK FOOTER //
// ./src/services/index.ts